export const DictionaryFromArrayUtil = (
  ids: string[]
): { [key: string]: string } => {
  let selectedEventDictionary: { [key: string]: string } = {};
  if (Array.isArray(ids)) {
    ids.forEach((el: string) => (selectedEventDictionary[el] = el));
  }
  return selectedEventDictionary;
};
